import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'
import './assets/css/index.css'
import './assets/css/App.css'
// import vConsole from './console'

ReactDOM.render(
    // <React.StrictMode>
    //     <App />
    // </React.StrictMode>,
    <App />,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
